const PRUEBAS = 'https://190.61.31.221:8443';
const PRODUCCION = 'https://190.61.31.224:8443';
const AWS = 'https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev';

export const URL_SERVICIO = PRODUCCION;
export const URL_AWS = AWS;
// export const URL_EMPLOYEE = "http://localhost:3001/dev"
export const URL_EMPLOYEE =
  'https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev';